import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalBuscarTrabajadorPage } from './modal-buscar-trabajador.page';

const routes: Routes = [
  {
    path: '',
    component: ModalBuscarTrabajadorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalBuscarTrabajadorPageRoutingModule {}
